module.exports = __webpack_public_path__ + "static/media/option1.a8909c72.png";